import AnnotationApi from './AnnotationApi';
export default AnnotationApi;
